import {DownloadOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import {DocumentFieldsFragment, Maybe, useDownloadDocumentMutation} from 'api/generated';
import {useAccessLevel} from 'hooks/useAccessLevel';
import React from 'react';
import {useParams} from 'react-router-dom';

type Props = {
  document?: Maybe<DocumentFieldsFragment>;
} & React.ComponentProps<typeof Button>;

export const DownloadDocument: React.FC<Props> = ({document, ...rest}) => {
  const {accountId} = useParams<{accountId: string}>();
  const {isAdmin} = useAccessLevel();

  const [downloadDocument, {loading: isDownloading}] = useDownloadDocumentMutation();

  if (!isAdmin || !document) return null;

  const handleDownloadDocument = async () => {
    const response = await downloadDocument({variables: {id: document.id, accountId}});
    const downloadUrl = response.data?.downloadDocument.downloadUrl;
    if (!downloadUrl) return;
    const newTab = window.open(downloadUrl, '_blank');
    newTab?.focus();
  };

  return (
    <Button
      {...rest}
      onClick={() => handleDownloadDocument()}
      loading={isDownloading}
      icon={<DownloadOutlined />}>
      Download
    </Button>
  );
};
